import { takeLatest } from 'redux-saga/effects'

import { SKIP_REVIEW } from 'Redux/actions/reviewsActions'
import onSkipReviewSuccess from './onSkipReviewSuccess'

export default function*() {
  yield takeLatest(SKIP_REVIEW.SUCCESS, onSkipReviewSuccess)
}
